'use client';

import React, { useState } from 'react';
import NavBar from '@/components/header/NavBar';

import Why from '@/components/home-page/whySection';
import ContactForm from '@/components/home-page/ContactForm';
import FAQContainer from '@/components/home-page/FAQContainer';
import Footer from '@/components/footer/Footer';
import Image from "next/image";



const ContactForms: React.FC = () => {




  return (
  
  <>
  {/* Fixed background — stays behind everything while page scrolls */}

  <div
    className="bg-cover bg-center bg-no-repeat h-96 lg:h-[500px] relative"
    style={{ backgroundImage: `url('/hero/seo.avif')` }}
  >
   
<div className="absolute inset-0 bg-secondary/55 h-96 lg:h-[500px] " />
  <h1 className="absolute inset-0 flex items-center pt-20 lg:pt-40 justify-center text-white text-5xl lg:text-9xl font-extrabold text-center px-4 ">
    Web Development & SEO
  </h1>
    
  </div>

  <NavBar />

  <section className="about-me-copy  bg-secondary">
          <div className="about-me-copy-wrapper">
            <h2 className='text-primary text-3xl lg:text-6xl py-8'>
              A great website isn't just built, it's engineered to perform.
              We build fast, scalable web applications and optimize them to
              rank, so your business gets found and grows online.
            </h2>

          </div>
        </section>

        <section className="services">
 <div className="services-col">
  <div className="services-banner">
    <Image
      src="/hero/web.avif"
      alt=""
      fill
      style={{ objectFit: "cover" }}
      sizes="(max-width: 768px) 100vw, 50vw"
    />
  </div>
</div>
          <div className="services-col ">
            <h4 className='text-2xl lg:text-3xl'>
              Every project we build combines solid engineering with search
              visibility in mind. We handle development, performance, and SEO
              together, so your site doesn't just look good, it gets results.
            </h4>

            <div className="services-list">
              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>Custom Web Development</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    From marketing sites to complex web applications, we build
                    with modern, scalable technology tailored to your
                    business — clean code, fast performance, and a
                    foundation that grows with you.
                  </p>
                </div>
              </div>

              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>SEO & Site Performance</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    We optimize every site for speed, structure, and search
                    visibility from day one — technical SEO, page speed, and
                    content strategy built in, not bolted on afterward.
                  </p>
                </div>
              </div>

              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>Testing, QA & Maintenance</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    We rigorously test every build for functionality and
                    performance, then keep it running smoothly with ongoing
                    updates, security monitoring, and technical support.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

<Why/>
<ContactForm/>

<FAQContainer
  title={"Web Development\n& SEO FAQs"}
  description="Answers to the most common questions clients ask about our web development process, timelines, technology, and SEO services."
  faq={[
    {
      question: "What technologies do you build websites with?",
      answer:
        "We build with modern, scalable frameworks like React and Next.js, tailored to your project's needs, performance goals, and long-term growth.",
    },
    {
      question: "Do you offer SEO as part of web development?",
      answer:
        "Yes — every site we build is optimized from the ground up for speed, structure, and search visibility, with optional ongoing SEO strategy and content support.",
    },
    {
      question: "How long does it take to build a website?",
      answer:
        "Most projects take 4–12 weeks depending on scope, from planning and design through development, testing, and launch.",
    },
    {
      question: "Will my website be mobile-friendly and fast?",
      answer:
        "Absolutely. Every site is built responsive-first and optimized for speed, since both directly impact user experience and search rankings.",
    },
    {
      question: "Do you provide ongoing maintenance after launch?",
      answer:
        "Yes — we offer maintenance plans covering updates, security monitoring, bug fixes, and performance tuning to keep your site running reliably.",
    },
    {
      question: "Can you improve the SEO of my existing website?",
      answer:
        "Yes, we perform technical SEO audits and implement on-page optimization, speed improvements, and content strategy to boost your existing site's rankings.",
    },
  ]}
/>
<Footer/>
</>
  );
};

export default ContactForms;